import "./navbar.css"
import SliderComp from "./component/slidercomponent.js"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import serviceone from "./esalab/services/icons8-ecg-100.png";
import servicetwo from "./esalab/services/icons8-exercise-100.png";
import servicethree from "./esalab/services/icons8-experiment-100.png";
import servicefour from "./esalab/services/icons8-ultrasound-100.png";
import servicefive from "./esalab/services/icons8-xray-100.png";
import pic1 from "./esalab/pic1.jpeg";
import pic2 from "./esalab/pic2.jpeg";
import pic3 from "./esalab/pic3.jpeg";
import pic4 from "./esalab/pic4.jpeg";
import pic5 from "./esalab/pic5.jpeg";
import pic6 from "./esalab/pic6.jpeg";
import { useRef } from "react";
import { Link } from "react-router-dom";
export default function Home(props){

    const reference = useRef(null);
    var settings = {
        dots: true,
        arrows:false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
      };
     return <div className="homepage">
        {/* <Slider {...settings} >
            <div className="bigsliderwrapper">
            <img className="sliderbigimage" src="https://dressalab.com/cdn/shop/files/Untitled-5-02_2000x.jpg?v=1676887395"/>
            </div>
            <div className="bigsliderwrapper">
            <img className="sliderbigimage" src="https://dressalab.com/cdn/shop/files/Mobile-Banner_767x.png?v=1671189369"/>
            </div>
            <div className="bigsliderwrapper">
            <img className="sliderbigimage" src="https://dressalab.com/cdn/shop/files/DELD_Feedback_SMC_2024_All_Sizes_-03_767x.jpg?v=1713525695"/>
            </div>
        </Slider> */}
        <section id="home_page">
            <div class="containerp">
                <div class="sliderp">
                    <div class="fslide slide-1">
                        <img src="data/images/home_images/homeimg-1.jpg" alt="f2"/>
                    </div>
                    <div class="fslide slide-2">
                        <img src="data/images/home_images/homeimag-2.jpg" alt="f2"/>
                    </div>
                    <div class="fslide slide-3">
                        <img src="data/images/home_images/homeimage-3.jpg" alt="f2"/>
                    </div>
                    <div class="fslide slide-4">
                        <img src="data/images/home_images/home-image-4.jpg" alt="f2"/>
                    </div>
                </div>
                <div class="fcontent">
                    <h1>
                        X-RAY AT YOUR HOME
                    </h1>
                    <p>
                        Our portable X-ray service brings advanced imaging technology directly to you, providing quick,
                        accurate diagnoses in the comfort of your home. Experience exceptional care and convenience with
                        our expert team.
                    </p>
                    <br/>
                    <a href="/book" class="bookingbutton">Book your Appoinmet</a>
                </div>
            </div>
        </section>
        <div className="servicesdiv" >
            <h1 className="servicebig">Services</h1>
            <div className="services">
            <Link to="/Electrocardiogram%20(ECG)" className="cardcomp">
                <img className="servicesicon" src={serviceone}/>
                <p className="servicetxt">ECG</p>
            </Link>
            <Link to="/Exercies%20Tolerance%20Test%20ETT" className="cardcomp">
                <img className="servicesicon" src={servicetwo}/>
                <p className="servicetxt">ETT</p>
            </Link>
            <Link className="cardcomp" onClick={()=>reference.current?.scrollIntoView({behavior: 'smooth'})}>
                <img className="servicesicon" src={servicethree}/>
                <p className="servicetxt">Blood Tests</p>
            </Link>
            <Link to="/Ultrasound" className="cardcomp">
                <img className="servicesicon" src={servicefour}/>
                <p className="servicetxt">Ultrasound</p>
            </Link>
            <Link to="/X-ray" className="cardcomp">
                <img className="servicesicon" src={servicefive}/>
                <p className="servicetxt">X-ray</p>
            </Link>
            </div>
        </div>

        <SliderComp refer={reference} setQuick={props.setQuick} setInd={props.setInd} upperrange={49} customstyles={false} arrows={true} slidesToScroll={3} lowerrange={0} title={"Lab Home Sample Collection"}/>
        <SliderComp setQuick={props.setQuick} setInd={props.setInd} upperrange={56} customstyles={false} lowerrange={50} title={"Ahk Lab's Health Package"}/>
        <SliderComp setQuick={props.setQuick} setInd={props.setInd} upperrange={79} customstyles={false} lowerrange={73} title={"Home Physiotherapy and Nursing"}/>
        <SliderComp setQuick={props.setQuick} setInd={props.setInd} upperrange={65} customstyles={true} pictures={[pic1,pic2,pic3,pic4,pic5,pic6]} titles={["Essa Labs","Health Solution","Lyfe Healthcare","Times Laboratory","Cure at Home","ZMT"]} lowerrange={57} title={"Our Key Partners"}/>
    </div>
}

